module.exports = __webpack_public_path__ + "img/chart_mathlab.521e6193.gif";